import { createSlice } from "@reduxjs/toolkit";

// UI state only. The filters are read from the URL (`hooks/useFormsFilters.ts`) and the rows come
// from React Query (`hooks/useFormInstances.ts`), so neither lives here any more.

type FormInstanceFormInstanceStatusCodes = "O" | "S" | "A"; // O:Open | S: Submitted | A: Approved
export type LayoutCodes = "L" | "D" | "T"; // L: List | D: Double Column | T: Triple Column

const FormsInitialState: {
	formInstanceModifiedRows: any[];

	formInstanceRows: any[];
	formInstanceSections: any[];
	formInstanceQuestions: any[];
	formsForUser: any[];

	selectedInstanceId: number | null;
	newInstanceId: number | string | null;
	newInstanceShift: string | null;
	newInstanceProductionDate: Date | null;
	newInstanceFormId: number | string | null;
	newInstanceAssetId: number | string | null;

	newInstanceShifts: any[];

	formComment: string;

	hasSubmitPermission: boolean;
	submitInitials: string;
	hasApprovePermission: boolean;
	approveInitials: string;
	formInstanceStatus: FormInstanceFormInstanceStatusCodes;

	openEditInstanceModal: boolean;
	refreshGrid: boolean;
	layoutCode: LayoutCodes;
	triggerEditIntance: boolean;
	apiMessage: string | null;
	selectedFormAsset: string | null;
	assetCodes: any;
} = {
	formInstanceModifiedRows: [],
	formInstanceRows: [],
	formInstanceSections: [],
	formInstanceQuestions: [],
	formsForUser: [],
	selectedInstanceId: null,
	newInstanceId: null,
	newInstanceShift: null,
	newInstanceProductionDate: null,
	newInstanceFormId: null,
	newInstanceAssetId: null,

	newInstanceShifts: [],

	formComment: "",
	hasSubmitPermission: true,
	submitInitials: "",
	hasApprovePermission: true,
	approveInitials: "",
	formInstanceStatus: "O",

	openEditInstanceModal: false,
	refreshGrid: false,
	layoutCode: "L",
	triggerEditIntance: false,
	apiMessage: null,

	selectedFormAsset: "",
	assetCodes: {},
};

export const FormsReducer = createSlice({
	name: "__",
	initialState: FormsInitialState,
	reducers: {
		setFormInstanceRows(state, { payload }) {
			state.formInstanceRows = payload;
		},
		setFormInstanceSections(state, { payload }) {
			state.formInstanceSections = payload;
		},
		setFormInstanceQuestions(state, { payload }) {
			state.formInstanceQuestions = payload;
		},
		setFormForUser(state, { payload }) {
			state.formsForUser = payload;
		},
		setNewInstanceShift(state, { payload }) {
			state.newInstanceShift = payload;
		},

		setNewInstanceProductionDate(state, { payload }) {
			state.newInstanceProductionDate = payload;
		},

		setNewInstanceFormId(state, { payload }) {
			state.newInstanceFormId = payload;
		},
		setNewInstanceAssetId(state, { payload }) {
			state.newInstanceAssetId = payload;
		},
		setNewInstanceId(state, { payload }) {
			state.newInstanceId = payload;
		},
		setSelectedInstanceId(state, { payload }) {
			state.selectedInstanceId = payload;
		},
		setNewInstanceShifts(state, { payload }) {
			state.newInstanceShifts = payload;
		},
		setFormInstanceModifiedRows(state, { payload }) {
			state.formInstanceModifiedRows = payload;
		},
		setHasSubmitPermissions(state, { payload }) {
			state.hasSubmitPermission = payload;
		},
		setHasApprovePermissions(state, { payload }) {
			state.hasApprovePermission = payload;
		},
		setSubmitInitials(state, { payload }) {
			state.submitInitials = payload;
		},
		setApproveInitials(state, { payload }) {
			state.approveInitials = payload;
		},
		setformComment(state, { payload }) {
			state.formComment = payload;
		},
		setFormInstanceStatus(state, { payload }) {
			state.formInstanceStatus = payload;
		},
		setOpenEditInstanceModal(state, { payload }) {
			state.openEditInstanceModal = payload;
		},
		setRefreshGrid(state, { payload }) {
			state.refreshGrid = payload;
		},
		setLayoutCode(state, { payload }) {
			state.layoutCode = payload;
		},
		setTriggerEditIntance(state, { payload }) {
			state.triggerEditIntance = payload;
		},
		setApiMessage(state, { payload }) {
			state.apiMessage = payload;
		},
		setSelectedFormAsset(state, { payload }) {
			state.selectedFormAsset = payload;
		},
		setAssetCodes(state, { payload }) {
			state.assetCodes = payload;
		},
	},
});
